export const VENDOR_LOGO_BASE = "https://storage.googleapis.com/prequel_assets/vendor-logos";

type VendorMeta = {
  label: string;
  logo: string;
};

// Vendors without a logo of their own fall back to a related one; VendorLogo renders a
// generic placeholder for anything unmapped.
const VENDOR_META: Record<string, VendorMeta> = {
  postgres: { label: "Postgres", logo: "postgres" },
  redshift: { label: "Redshift", logo: "redshift" },
  redshift_serverless: { label: "Redshift Serverless", logo: "redshift" },
  bigquery: { label: "BigQuery", logo: "bigquery" },
  snowflake: { label: "Snowflake", logo: "snowflake" },
  s3: { label: "S3", logo: "s3" },
  s3_compatible: { label: "S3 Compatible", logo: "s3" },
  abs: { label: "Azure Blob Storage", logo: "abs" },
  gcs: { label: "Google Cloud Storage", logo: "gcs" },
  sftp: { label: "SFTP", logo: "sftp" },
  delta_sharing: { label: "Delta Sharing", logo: "delta_sharing" },
};

export const getVendorLabel = (vendor: string) => VENDOR_META[vendor]?.label ?? "Unknown";

export const getVendorLogoUrl = (vendor: string) => {
  const logo = VENDOR_META[vendor]?.logo;
  return logo ? `${VENDOR_LOGO_BASE}/${logo}.svg` : "";
};
